import React from "react";
import {
  Box,
  Flex,
  Heading,
  Text,
  Button,
  VStack,
  useColorModeValue,
  Container, // Import Container
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import { Link as RouterLink } from "react-router-dom";

const NotFoundPage = () => {
  // Theme Colors
  const textColor = useColorModeValue("brand.700", "white");
  const bgColor = useColorModeValue("brand.50", "gray.900");

  return (
    <Box bg={bgColor} minH="100vh" display="flex" alignItems="center" justifyContent="center"> {/* Center content vertically */}
      <Container maxW="container.md"> {/* Use Container for better responsiveness */}
        <Flex
          direction="column" // Stack content vertically
          align="center"
          textAlign="center"
          py={16} // Reduced padding
          px={8}
          bgGradient="linear(to-r, brand.500, brand.400)"
          color="white"
          borderRadius="lg" // Add rounded corners
          boxShadow="lg" // Add a subtle shadow
        >
          <VStack spacing={6} maxW="600px">
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <Heading size="2xl" fontWeight="bold" textShadow="0px 4px 10px rgba(0, 0, 0, 0.3)">
                404 - Page Not Found
              </Heading>
            </motion.div>
            <Text fontSize="lg" opacity={0.9}>
              Oops! The page you are looking for doesn’t exist or has been moved.
            </Text>
            <Button
              as={RouterLink}
              to="/"
              size="lg"
              bg="white"
              color="brand.500"
              _hover={{ bg: "blue.100", transform: "scale(1.05)" }}
              transition="0.3s"
            >
              Go to Home
            </Button>
          </VStack>
        </Flex>
      </Container>
    </Box>
  );
};

export default NotFoundPage;